import AreaCookieController from './area_cookie_controller'
import AreaRecommendationsController from './area_recommendations_controller'

window.Stimulus.register('area-cookie', AreaCookieController)
window.Stimulus.register('area-recommendations', AreaRecommendationsController)